import { render } from "./SchemeList.vue?vue&type=template&id=afe9c4ec&scoped=true&ts=true"
import script from "./SchemeList.vue?vue&type=script&lang=ts"
export * from "./SchemeList.vue?vue&type=script&lang=ts"

import "./SchemeList.vue?vue&type=style&index=0&id=afe9c4ec&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afe9c4ec"]])

export default __exports__